<div [ngClass]="containerClass() || 'flex flex-col items-start relative'">
  <label for="address" class="text-sm font-medium"
         [class.sr-only]="!label()">{{ label() || ('SHARED.PLACES_AUTOCOMPLETE.LABEL' | translate) }}</label>
  <div class="relative w-full">
    <input #searchInput (input)="onInput()" type="text" name="address" id="address"
           [placeholder]="placeholder()" autocomplete="address-line1"
           [attr.aria-label]="'SHARED.PLACES_AUTOCOMPLETE.ADDRESS_LABEL' | translate"
           [ngClass]="inputClass() || defaultInputClass">
    <lucide-icon [img]="MapPinned" [size]="20" [ngClass]="iconClass() || defaultIconClass" aria-hidden="true"/>
  </div>
</div>
